import styled from 'styled-components';

export const TeacherItem = styled.div`
margin-bottom: 20px;
margin-top: ${props => props.active ? " -29px" : "0px"};
position: relative;
overflow: hidden;
img{
  width: 100%;
  height: 310px;  
  border-radius: 10px;
}
:hover div  div:last-child{
  bottom: 0;
}
:hover >div{
  transform: scale(1);
}
  `;

export const TeacherInfo = styled.div`
text-align:center;
background-color: var(--primaryColor);
position: absolute;
position: absolute;
bottom: 10px;
left: 10px;
right: 10px;
padding: 20px ;
border-radius: 10px;
transform: scale(0);
  a{
    font-size: 15px;
    font-weight: 700;
    color: white;
    }
  p{
    font-size: 13px;
    color: white;
  }
  hr{
    margin: 7px 0px;
    background-color:#aba7a7;
}  
  `;

export const TeacherIcons = styled.div`
display: flex;
justify-content: center;
align-items: center;
background-color:  var(--primaryColor);
transition: all .3s ease;
span{
  line-height: 33px;
  text-align: center;
  color: white;
  cursor: pointer;
  width: 30px;
  font-size: 12px;
}
`;

// export const EventInfo = styled.div`
// display: flex;
// justify-content: space-between;
//   >span {
//     height: 36px;
//     background-color: #e2e2e2;
//     width: 2px;
//     display: block;
//   }
// `;

// export const EventInfoItem = styled.div`
// padding: 0px 8px;
// i , span{
//   font-size: 14px;
//   color: #55585a;
// }
// i{
//   margin: 0px 4px;
// }
// `;
